import {ShareModule} from "@share/share.module";
import {NgModule} from "@angular/core";
import {ParametreFormulaireComponent} from "@components/admin/parametre/formulaire/parametre-formulaire.component";
import {FormulaireOmpComponent} from "@components/admin/parametre/formulaire/formulaire-omp/formulaire-omp.component";
import {FormulaireOmpService} from "@components/admin/parametre/formulaire/formulaire-omp/formulaire-omp.service";
import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {FormulaireOmComponent} from "@components/admin/parametre/formulaire/formulaire-om/formulaire-om.component";
import {FormulaireOmService} from "@components/admin/parametre/formulaire/formulaire-om/formulaire-om.service";
import {FormulaireVoyageComponent} from "@components/admin/parametre/formulaire/formulaire-voyage/formulaire-voyage.component";
import {FormulaireVoyageService} from "@components/admin/parametre/formulaire/formulaire-voyage/formulaire-voyage.service";
import {FormulaireNdfComponent} from "@components/admin/parametre/formulaire/formulaire-ndf/formulaire-ndf.component";
import {FormulaireNdfService} from "@components/admin/parametre/formulaire/formulaire-ndf/formulaire-ndf.service";
import {FormulaireFactureComponent} from "@components/admin/parametre/formulaire/formulaire-facture/formulaire-facture.component";
import {FormulaireFactureService} from "@components/admin/parametre/formulaire/formulaire-facture/formulaire-facture.service";
import {FormulaireAvanceComponent} from "@components/admin/parametre/formulaire/formulaire-avance/formulaire-avance.component";
import {FormulaireAvanceService} from "@components/admin/parametre/formulaire/formulaire-avance/formulaire-avance.service";

export const parametreFormulaireRoutes: Routes = [
    {
        path: 'Omp',
        component: FormulaireOmpComponent,
        canActivate: [AdminGuardProvider],
    },{
        path: 'Om',
        component: FormulaireOmComponent,
        canActivate: [AdminGuardProvider],
    },{
        path: 'Voyage',
        component: FormulaireVoyageComponent,
        canActivate: [AdminGuardProvider],
    },{
        path: 'Ndf',
        component: FormulaireNdfComponent,
        canActivate: [AdminGuardProvider],
    },{
        path: 'Avance',
        component: FormulaireAvanceComponent,
        canActivate: [AdminGuardProvider],
    },{
        path: 'Facture',
        component: FormulaireFactureComponent,
        canActivate: [AdminGuardProvider],
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'Omp'
    },
    {
        path: '**',
        redirectTo: 'Omp'
    }];


@NgModule({
    imports: [
        ShareModule,
    ],
    declarations: [
        ParametreFormulaireComponent,
        FormulaireOmpComponent,
        FormulaireOmComponent,
        FormulaireVoyageComponent,
        FormulaireNdfComponent,
        FormulaireAvanceComponent,
        FormulaireFactureComponent,
    ],
    exports: [
        ParametreFormulaireComponent,
    ],
    providers: [
        FormulaireOmpService,
        FormulaireOmService,
        FormulaireVoyageService,
        FormulaireNdfService,
        FormulaireAvanceService,
        FormulaireFactureService,
    ]
})
export class ParametreFormulaireModule {
}